"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_cookie_1 = __importDefault(require("js-cookie"));
var REQUEST_COUNT_COOKIE_NAME = 'fh-cookie-guard-request-count';
var AutoAcceptRequestWatcher = (function () {
    function AutoAcceptRequestWatcher(cookieConsentStore, autoAcceptCookieConsentAfterRequestCount, cookieAttributes, onAutoAcceptCallback) {
        if (onAutoAcceptCallback === void 0) { onAutoAcceptCallback = null; }
        this.currentRequestCount = 0;
        this.cookieConsentStore = cookieConsentStore;
        this.autoAcceptCookieConsentAfterRequestCount = autoAcceptCookieConsentAfterRequestCount;
        this.cookieAttributes = cookieAttributes;
        this.onAutoAcceptCallback = onAutoAcceptCallback;
        this.setCurrentRequestCount();
        this.watchCurrentRequestCount();
    }
    AutoAcceptRequestWatcher.prototype.setCurrentRequestCount = function () {
        var requestCountFromSession = js_cookie_1.default.get(REQUEST_COUNT_COOKIE_NAME);
        this.currentRequestCount = requestCountFromSession ? parseInt(requestCountFromSession) : 0;
    };
    AutoAcceptRequestWatcher.prototype.watchCurrentRequestCount = function () {
        if (this.currentRequestCount < this.autoAcceptCookieConsentAfterRequestCount) {
            var newRequestCount = this.currentRequestCount + 1;
            this.setRequestCounterSessionCookie(newRequestCount);
            return;
        }
        this.cookieConsentStore.accept();
        if (typeof this.onAutoAcceptCallback === 'function') {
            this.onAutoAcceptCallback();
        }
    };
    AutoAcceptRequestWatcher.prototype.setRequestCounterSessionCookie = function (value) {
        var _a = this.cookieAttributes, domain = _a.domain, path = _a.path;
        js_cookie_1.default.set(REQUEST_COUNT_COOKIE_NAME, value.toString(), {
            domain: domain,
            path: path
        });
    };
    return AutoAcceptRequestWatcher;
}());
exports.default = AutoAcceptRequestWatcher;
